import { useParams } from "react-router";
import CoreDeviceReportedState from "@gf-core/widgets/widgets/CoreDeviceReportedState";

export default function ReportedStateTab() {
  const { installationId } = useParams();

  if (!installationId) return;
  return (
    <CoreDeviceReportedState
      id={`installation-reported-state-${installationId ?? ""}`}
      installationId={installationId ?? ""}
      inlinePadding={0}
      listConfiguration={{
        pageSize: 20,
      }}
    />
  );
}
